import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { IAttributes } from 'src/app/models/IAttributes';
import { IAssessment, IASCType } from 'src/app/models/IAssessment';
import { IConsentforms } from 'src/app/models/IConsentforms';
import { configuration } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })

export class AssessmentClinicService {

  constructor(private http: HttpClient) { }


  //   saveROSDetails(ROSInfo: ISaveSubComp): Observable<ISaveSubComp> {
  //     return this.http.post<ISaveSubComp>(`${configuration.clinicapiUrl + 'Encounter/SetROSDetails'}`, ROSInfo, {
  //       headers: new HttpHeaders({ 'content-Type': 'application/json' })
  //     });
  //   }

  getMasterData(): Observable<IAttributes[]> {
    const postdata ={
      loggedUser:encodeURIComponent(sessionStorage.getItem("userId")),
      facilityId:sessionStorage.getItem("FacilityId"),
      encounterId:sessionStorage.getItem("encounterid"),
      LocationID:sessionStorage.getItem("LocationId")
    }
    return this.http.post<IAttributes[]>(`${configuration.clinicapiUrl + 'Master/ASCMasterData'}`, postdata);
  }

  getAssessmentDetails(encId: string, userId: string): Observable<IAssessment> {
    return this.http.get<IAssessment>(`${configuration.clinicapiUrl + 'Encounter/AssessmentDetails'}?userid=${userId}&&encid=${encId}`);
  }
  // saveAssessment(assessmentInfo: IAssessment): Observable<IAssessment> {
    
  //   assessmentInfo.pastMedicalHistory.map(x=>x.toString());
  //   return this.http.post<IAssessment>(`${configuration.clinicapiUrl + 'Encounter/SetAssessment'}`, assessmentInfo, {
  //     // headers: new HttpHeaders({ 'content-Type': 'application/json' })
  //   });
  // }
  saveAssessment(assessmentInfo: IAssessment): Observable<IAssessment> {
    
    const posteddata={
      inputdata:JSON.stringify(assessmentInfo)
    } 
    return this.http.post<IAssessment>(`${configuration.clinicapiUrl + 'Encounter/SetAssessment'}`, posteddata, {
      // headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  saveLock(IsLocked: Boolean, encId: string): Observable<string> {
    return this.http.put<string>(`${configuration.clinicapiUrl + 'Encounter/SetLock'}?IsLocked=${IsLocked}&&encounterId=${encId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getPastMedicalHistory(patientId: number): Observable<string> {
    return this.http.get<string>(`${configuration.clinicapiUrl + 'Encounter/PastMedicalHistoy'}?PatientId=${patientId}`);
  }

  // UpdateSelectIcdCodeInfo(encId :string, Icd: string): Observable<number> {
  //   return this.http.put<number>(`${configuration.clinicapiUrl + 'Encounter/SelectIcd'}?encid=${encId}&&icd=${Icd}&&userid=admin`, {
  //     headers: new HttpHeaders({ 'content-Type': 'application/json' })
  //   });
  // }

  DeleteSelectMedicationInfo(Id: number): Observable<number> {
    return this.http.delete<number>(`${configuration.clinicapiUrl + 'Encounter/Medication'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteSelectPreOpTestResult(Id: number): Observable<number> {
    return this.http.delete<number>(`${configuration.clinicapiUrl + 'Encounter/PreopTestResult'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteSelectPreOpTestResultByEncounterId(EncounterId: string): Observable<string> {
    return this.http.delete<string>(`${configuration.clinicapiUrl + 'Encounter/PreopTestResultByEncId'}?EncounterId=${EncounterId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteSelectVitalSign(Id: number): Observable<number> {
    return this.http.delete<number>(`${configuration.clinicapiUrl + 'Encounter/VitalSign'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  saveAssessmentName(assessmentTypeInfo: IAttributes): Observable<IAttributes> {
    return this.http.post<IAttributes>(`${configuration.clinicapiUrl + 'Master/AssessmentName'}`, assessmentTypeInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getConsentFormSignatures(encId: string, userId: string): Observable<IConsentforms> {
    return this.http.get<IConsentforms>(`${configuration.clinicapiUrl + 'Encounter/getConsentFormSignatures'}?userid=${userId}&&encid=${encId}`); //&& userid=admin
  }

  updateLockStatus(encounterId: string, isSignedOff: boolean, modified: string): Observable<string> {
    return this.http.put<string>(`${configuration.clinicapiUrl + 'Encounter/AssesmentUpdateLock'}?encounterId=${encounterId}&&isSignedOff=${isSignedOff}&&modifiedBy=${modified}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // getMasterDataByAttributeType(attributeType: string): Observable<IAttributes[]> {
  //   return this.http.get<IAttributes[]>(`${configuration.clinicapiUrl + 'Master/ASCMasterDataByAttributeType'}?loggedUser=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${sessionStorage.getItem("FacilityId")}&&encounterId=${sessionStorage.getItem("encounterid")}&&attributeType=${attributeType}`);
  // }

  getMasterDataByAttributeType(attributeType: string): Observable<IAttributes[]> {
    const postdata={
        facilityId:sessionStorage.getItem("FacilityId"),
        attributeType:attributeType,
        encounterId:sessionStorage.getItem("encounterid"),
        loggedUser:encodeURIComponent(sessionStorage.getItem("userId")).toString()
        }
        return this.http.post<IAttributes[]>(`${configuration.clinicapiUrl + 'Master/ASCMasterDataByAttributeType'}?locationId=${sessionStorage.getItem("LocationId")}`,postdata,{
            headers: new HttpHeaders({ 'content-Type': 'application/json' })
          });
        }
        
  GetAllASCMasterDataWithData(autostring: string): Observable<IAttributes[]> {
    const posteddata={
      loggedUser:encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      facilityId:sessionStorage.getItem("FacilityId"),
      encounterId:sessionStorage.getItem("encounterid"),
      LocationID:sessionStorage.getItem("LocationId"),
      autoParam:autostring
    }
    return this.http.post<IAttributes[]>(`${configuration.clinicapiUrl + 'Master/DeleteASCMasterData'}`,posteddata);
  }
}
